import React, { useRef } from 'react';

// 鼠标跟随 3D 倾斜（仅在支持 hover 的设备上生效，触屏不启用以免卡住）
export default function Tilt({ children, className, style, max = 8 }) {
  const ref = useRef(null);
  const canHover = typeof window !== 'undefined'
    && window.matchMedia && window.matchMedia('(hover: hover)').matches;

  const onMove = (e) => {
    if (!canHover) return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(800px) rotateX(${(-py * max).toFixed(2)}deg) rotateY(${(px * max).toFixed(2)}deg) translateY(-4px)`;
  };
  const onLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = '';
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={className}
      style={{ transition: 'transform 0.18s ease', willChange: 'transform', ...style }}
    >
      {children}
    </div>
  );
}